<template>
  <b-card>
    <b-container>
      <div>
        <div
          style="display: flex; flex-direction: column; justify-items: center; align-items: center"
        >
          <img :src="paperless" class="warranty-logo" style="width: 75%;" />
        </div>

        <div class="section-data">
          <h5></h5>
          <div class="unavailable-message">
            <p style="font-weight: bold; color: red; margin-bottom: 20px;">
              Warranty Registration Website Maintenance Notice
            </p>
            <p style="margin-bottom: 15px;">
              To improve our services, the Warranty Registration website will be temporarily unavailable from 10th of January 2026.
            </p>
            <p style="margin-bottom: 15px;">
              Warranty Registration website will be available from 13th of January 2026.
            </p>
            <p>
              Thank you for your patience and continued support.
            </p>
          </div>
        </div>
      </div>
    </b-container>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      paperless: require("@/assets/images/drcc/daikin-paperless.png"),
    };
  },
};
</script>

<style scoped>
.section-data {
  padding: 15px 10px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  position: relative;
  margin: 20px 0 20px 0;
}

.section-data h5 {
  position: absolute;
  top: -10px;
  left: 6px;
  background: white;
  padding: 0 10px;
}

.unavailable-message {
  padding: 20px 10px;
  text-align: center;
  font-size: 1.1em;
  line-height: 1.6;
}

@media only screen and (max-width: 500px) {
  .warranty-logo {
    width: 100%;
    height: auto;
  }

  .unavailable-message {
    font-size: 1em;
    padding: 15px 5px;
  }
}
</style>
